<script setup>
import { onMounted, computed, ref } from "vue";
import { useStore } from "vuex";
import vSelect from "vue-select";
import "vue-select/dist/vue-select.css";
import _ from "lodash";
import axios from "axios";
import { authHeader } from "@/helpers/authservice/auth-header";

// const props = defineProps({
//   editable: {
//     type: Boolean,
//     default: true,
//   },
//   lgu_has_speed_violation: {
//     type: Array,
//     required: true,
//   },
// });

onMounted(async () => {
  await getMVFileRecord();
  await searchQuery();
  original_name.value = mv_file_record.value.name;
});

const traffic_record = computed(
  () => store.state.trafficRecordComponent.traffic_record
);
 
const mv_file_record = computed({
  get: () => store.state.trafficRecordComponent.selected_mv_file_record,
  set: (val) => store.commit("trafficRecordComponent/SET_SELECTED_MV_FILE_RECORD", val),
});

const original_name = ref(null);

const store = useStore();

const getMVFileRecord = async () =>
  await store.dispatch("trafficRecordComponent/getSelectedMVFileRecord");

const loading = computed(() => store.state.globals.loading);

const searchQuery = _.debounce(async (loading = false, search = "") => {
  const { data } = await axios.get(
    `/traffic_record_component/mv_file_record/city-list?search=${escape(
      search
    )}`,
    {
      headers: authHeader(),
    }
  );
  city_list.value = data.data;
  if (loading) {
    loading(false);
  }
}, 350);

const city_list = ref([]);
</script>

<template>
  <b-overlay :show="loading">
    <div class="row">
      <div
        class="col-12"
      >
        <div
          class="card"
        >
          <div class="card-body overflow-auto">
            <table class="table table-bordered table-sm table-light m-0">
              <tbody>
                <tr>
                  <th colspan="2" class="text-center">Notice of Violation Record - City Sorting </th>
                </tr>
                <tr>
                  <td colspan="2">
                    <label class="text-bold">Filename</label>
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      :value="traffic_record.filename"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <label class="text-bold">Notice of Violation Number</label>
                    <input
                      type="text"
                      class="form-control"
                      disabled
                      :value="traffic_record.violation_penalties[0].notice_of_violation_number"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <label class="text-bold">Owner Address</label>
                    <textarea
                      disabled
                      rows="2"
                      type="text"
                      class="form-control"
                      :value="mv_file_record.current_owner_address"
                    />
                  </td>
                </tr>
                <tr>
                  <td colspan="2">
                    <label class="text-bold">City/Municipality, Province</label>
                    <div class="row">
                      <div class="col-md-12">
                        <v-select
                          :options="city_list"
                          placeholder="Select City"
                          :get-option-label="
                            (option) => {
                              return `${option.name + ', ' + option.province}`;
                            }
                          "
                          :value="city_list"
                          :reduce="(cities) => cities.id"
                          append-to-body
                          v-model="mv_file_record.city_id"
                        />
                      </div>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </b-overlay>
</template>

<style>
.vs--searchable .vs__dropdown-toggle {
  background: white;
}

:root {
  --vs-font-size: 0.8rem;
}
</style>
